import { defineStore } from "pinia";
import { reactive, toRefs } from "vue";

import { DictionariesService, ProductsService } from "@/services";
import type { Dictionary, PrivateProduct } from "@/types";

interface State {
  status: "initial" | "loaded" | "failed";
  products: PrivateProduct[];
  dictionaries: Dictionary[];
}

export const useProductsStore = defineStore("products", () => {
  const state = reactive<State>({ status: "initial", products: [], dictionaries: [] });

  const load = async () => {
    try {
      state.products = await ProductsService.getProducts();
      state.status = "loaded";

      // Load dictionaries async to prevent blocking the UI
      DictionariesService.getDictionaries().then((dictionaries) => {
        state.dictionaries = dictionaries;
      });
    } catch (e) {
      state.status = "failed";
      throw e;
    }

    return state.products;
  };

  const reset = () => {
    state.status = "initial";
    state.products = [];
  };

  return {
    ...toRefs(state),
    load,
    reset
  };
});
